import React from 'react';
// import './../../styles/testimonials.css';
import './../../styles/testimonial.css';

const testimonialsData = [
    // Column 1 (Left side of the grid)
    {
        id: 1,
        name: "Patrick Ndirangu",
        role: "CEO, 21Knights Engineering Group",
        avatar: "https://i.pravatar.cc/150?u=patrick", // Placeholder image
        text: "The platform has revolutionized how we handle our construction projects. As a project manager overseeing multiple sites, having both web and mobile access means I can stay on top of everything whether I'm in the office or on-site. The interface is intuitive, and it's dramatically reduced the time we spend on paperwork and coordination.",
        isLogoAvatar: true,
        logoColor: "#FF5733"
    },
    {
        id: 2,
        name: "Michael Wafula",
        role: "IT & Systems Manager, DeltaWorks Engineering",
        avatar: "https://i.pravatar.cc/150?u=michael",
        text: "From initial setup to go-live, ConRa's team supported us every step of the way. Their responsiveness and attention to our unique workflows meant we didn't have to compromise on how we manage our projects. The interface is intuitive and responsive, even on mobile.",
        isLogoAvatar: false
    },
    {
        id: 3,
        name: "James Kariuki",
        role: "Subcontractor UrbanEdge Contractors",
        avatar: "https://i.pravatar.cc/150?u=james",
        text: "ConRa has completely changed how we manage communication between field teams and designers. The centralized dashboard keeps everyone aligned — no more outdated drawings or lost WhatsApp updates. Our project turnaround time has improved noticeably.",
        isLogoAvatar: false
    },
    // Column 2 (Right side of the grid)
    {
        id: 4,
        name: "Sarah Odhiambo",
        role: "Regional Director, EastBuild Africa",
        avatar: "https://i.pravatar.cc/150?u=sarah",
        text: "We're working on multiple simultaneous projects across Kenya and Uganda, and ConRa gives us the visibility we lacked. I can pull up inspection reports, compliance logs and upcoming deadlines from my phone. It's become an essential tool for our regional team.",
        isLogoAvatar: false
    },
    {
        id: 5,
        name: "Fatima Hassan",
        role: "Senior Site Engineer, Skyline Developments",
        avatar: "https://i.pravatar.cc/150?u=hassan",
        text: "On our latest high-rise project, ConRa allowed us to track tasks, set deadline alerts and monitor inspection findings in real time. The transparency it brought meant our stakeholders were kept informed, and we reduced rework-related delays by an estimated 25%.",
        isLogoAvatar: false
    },
    {
        id: 6,
        name: "Ruth Nzoki",
        role: "Project Owner, Ruwac Holdings",
        avatar: "https://i.pravatar.cc/150?u=ruth",
        text: "As a project owner, I appreciate how ConRa gives me clear visibility into progress without having to call the site daily. The reports and analytics are straightforward, helping me make faster, data-driven decisions.",
        isLogoAvatar: true,
        logoColor: "#A3A3FF"
    }
];

// Helper to split data into two columns for the masonry effect
const column1 = [testimonialsData[0], testimonialsData[1], testimonialsData[2]];
const column2 = [testimonialsData[3], testimonialsData[4], testimonialsData[5]];

const TestimonialCard = ({ data }) => (
    <div className="testimonial-card">
        <div className="card-header">
            <div className="avatar-container">
                {data.isLogoAvatar ? (
                    <div className="avatar-logo" style={{ backgroundColor: data.logoColor || '#ddd' }}>
                        <span className="logo-initial">{data.name.charAt(0)}</span>
                    </div>
                ) : (
                    <img src={data.avatar} alt={data.name.charAt(0)} className="avatar-img" />
                )}
            </div>
            <div className="user-info">
                <h4 className="user-name">{data.name}</h4>
                <p className="user-role">{data.role}</p>
            </div>
        </div>
        <div >
            <p className="testimonial-text">{data.text}</p>
        </div>
    </div>
);

const Testimonials = () => {
    return (
        <section className="testimonial-container">
            <div className="testimonials-section">
                <div className="content-wrapper">
                    {/* Left Side: Text Content */}
                    <div className="intro-column">
                        <h2 className="main-heading">
                            What <span className="highlight-blue">Our Customers</span> <br />
                            Are Saying
                        </h2>
                        <p className="intro-text">
                            Join the ranks of industry leaders who have transformed their operations with our innovative solutions. Our commitment to excellence and customer satisfaction is reflected in the success stories of our diverse clients.
                        </p>
                    </div>

                    {/* Right Side: Masonry Grid */}
                    <div className="cards-grid">
                        <div className="grid-column column-down">
                            {column1.map(item => <TestimonialCard key={item.id} data={item} />)}
                        </div>
                        <div className="grid-column column-up">
                            {column2.map(item => <TestimonialCard key={item.id} data={item} />)}
                        </div>
                    </div>

                </div>
            </div>

        </section>
    );
};

export default Testimonials;